// Example service: filepath: /home/boss/workspace/pwa/zgrana/src/app/services/example.service.ts
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { News } from '../interfaces/news.interface';
import { GenericResponseWithTotal } from '../interfaces/generic.interface';
import { Observable } from 'rxjs';
import { DataProcessingService } from './data-prcessing.service';
import { Log } from '../interfaces/logs.interface';
import { LoggerService } from './logger.service';

@Injectable({ providedIn: 'root' })
export class LogsService {
  private get apiUrl(): string {
    return this.loggerService.resolveApiUrl('logs');
  }

  constructor(
    private http: HttpClient,
    private dataProcess: DataProcessingService,
    private loggerService: LoggerService
  ) { }

  getList(params?: {
    order_by?: string;
    order?: string;
    skip?: number;
    limit?: number;
    [key: string]: any; // for filters
  }): Observable<GenericResponseWithTotal<Log>> {
    console.log('Fetching logs with params:', params);
    return this.http.get<GenericResponseWithTotal<Log>>(this.apiUrl, { params: this.dataProcess.fitlerParams(params) });
  }

  setLogs(error: string): Observable<void> {
    return this.http.post<void>(this.apiUrl + '/frontend-error', { error });
  }

}